import { Card, CardBody, Col, Row } from 'react-bootstrap';
import { useRmxServiceApi } from '../api';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Spinner } from '../../shared-compat/DataTable/DataTable';
import { createDisposingObjectUrl } from '../../utils/react-query/queryClientDisposeOnCacheEvict';
import { PdfViewer } from '../../../components/util/PdfViewer/PdfViewer';

interface Props {
  sampleId: number;
  enabled?: boolean;
}

export function SampleReportPdf({ enabled, sampleId }: Props) {
  const api = useRmxServiceApi();

  const {
    data: sampleReportPdf,
    isError,
    isFetching
  } = useQuery({
    queryKey: ['sample-report', sampleId],
    enabled: enabled ?? true,
    retry: 0,
    queryFn: async () => {
      const pdf = await api.getSampleReportPdf(sampleId);
      return createDisposingObjectUrl(pdf!);
    }
  });

  return (
    <div>
      <Row>
        <Col>
          <Card>
            <CardBody style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
              {isFetching ? (
                <Spinner />
              ) : sampleReportPdf ? (
                <div style={{ cursor: 'pointer' }}>
                  <PdfViewer pdfUrl={sampleReportPdf.url} />
                </div>
              ) : (
                <div>{isError ? <span>Error loading sample report.</span> : <span>No sample report available.</span>}</div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
